import { Button } from "@grantyd/ui";
import { Link } from "react-router-dom";
import { ReactComponent as InstagramIcon } from "@/assets/icons/instagram.svg";
import { ReactComponent as LinkedInIcon } from "@/assets/icons/linkedin.svg";
import { footerData } from "@/data/footer";
import styles from "./Footer.module.css";

const Footer = () => {
  const handleCookieSettings = () => {
    localStorage.removeItem("cookies");
    window.location.reload();
  };

  return (
    <footer className={styles.footer} id="contact">
      <div className={styles.main}>
        <div className={styles.section}>
          <p className={styles.title}>{footerData.mainSection.heading}</p>
          <Link to={footerData.mainSection.cta.link}>
            <Button variant="tertiary" style={{ width: "208px" }}>
              {footerData.mainSection.cta.text}
            </Button>
          </Link>
        </div>

        <div className={styles.middleSections}>
          <div className={styles.section}>
            <p className={styles.sectionTitle}>{footerData.support.heading}</p>
            {footerData.support.links.map(
              (link) => (
                // link.isExternal ? (
                <a key={link.text} href={link.href} className={styles.link}>
                  {link.text}
                </a>
              )
              // ) : (
              //   <Link key={link.text} to={link.link!} className={styles.link}>
              //     {link.text}
              //   </Link>
              // )
            )}
          </div>

          <div className={styles.section}>
            <p className={styles.sectionTitle}>{footerData.social.heading}</p>
            <div className={styles.socialIcons}>
              {footerData.social.links.map((social) => (
                <a
                  key={social.platform}
                  href={social.url}
                  className={styles.icon}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {social.platform === "instagram" ? (
                    <InstagramIcon />
                  ) : (
                    <LinkedInIcon />
                  )}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <p className={styles.sectionTitle}>{footerData.company.heading}</p>
          {footerData.company.links.map((link) => (
            <a key={link.text} href={link.link} className={styles.link}>
              {link.text}
            </a>
          ))}
        </div>
      </div>

      <div className={styles.bottom}>
        <p className={styles.copyright}>{footerData.bottom.copyright}</p>
        <div className={styles.bottomLinks}>
          {footerData.bottom.legal.map((link) => (
            <a key={link.text} href={link.link} className={styles.link}>
              {link.text}
            </a>
          ))}
          <button className={styles.link} onClick={handleCookieSettings}>
            {footerData.bottom.cookieSettings}
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
